/**
 * Authentication hook backed by WorkOS session.
 *
 * Replaces config-based identity with session-based auth.
 * Maintains backward-compatible User interface for existing components.
 *
 * Blueprint: CXS2 session-based auth pattern.
 */

import { useAuthContext, type AuthUser } from '../context/AuthContext';

// Backward-compatible User type for existing components
export interface User {
  id: string;
  name: string;
  org_id: string;
  org_name: string;
}

function mapAuthUser(authUser: AuthUser, orgId: string | null, orgName: string | null): User {
  const name = [authUser.first_name, authUser.last_name].filter(Boolean).join(' ') || authUser.email;
  return {
    id: authUser.id,
    name,
    org_id: orgId || '',
    org_name: orgName || '',
  };
}

export function useAuth() {
  const { user, organization, isAuthenticated, loading, error, logout } = useAuthContext();

  return {
    user: user ? mapAuthUser(user, organization?.id ?? null, organization?.name ?? null) : null,
    isAuthenticated,
    loading,
    error,
    logout,
  };
}
